import { call, put, takeLatest } from 'redux-saga/effects';
import HeroAccountAPI from 'api-services/HeroAccountApi';
import { isSuccessResponse } from 'api-services/types/guards';
import { checkUserHelper } from '../utils/helperSagas';
import { GET_SAFETY_SETTINGS, SET_SAFETY_SETTINGS } from './actionTypes';
import { doneGetSafetySettings, errorGetSafetySettings, doneSetSafetySettings, errorSetSafetySettings } from './actionCreators';
import { logout } from '../auth/actionCreators';
export function* safetySettings(constAccessParams) {
    // Check public API access token
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    const result = yield call(HeroAccountAPI.getSafetySettings, newAccessParams);
    if (isSuccessResponse(result)) {
        yield put(doneGetSafetySettings(result.data));
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    else {
        yield put(errorGetSafetySettings(result));
    }
}
export function* safetySettingsCall(constAccessParams) {
    yield takeLatest(GET_SAFETY_SETTINGS, safetySettings, constAccessParams);
}
export function* setSafetySettings(constAccessParams, action) {
    // Check public API access token
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    const result = yield call(HeroAccountAPI.updateSafetySettings, newAccessParams, action.data.max_dose_dispense_time);
    if (isSuccessResponse(result)) {
        yield put(doneSetSafetySettings(action.data));
        yield call(safetySettings, constAccessParams);
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    else {
        yield put(errorSetSafetySettings(result));
    }
}
export function* setSafetySettingsCall(constAccessParams) {
    yield takeLatest(SET_SAFETY_SETTINGS, setSafetySettings, constAccessParams);
}
//# sourceMappingURL=saga.js.map